import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import loadKakaoMaps from './kakaoMaps';
import tokens from '../theme/tokens';

// 경로 지도 — 카카오 지도 위에 실제 도로 경로(path: [[lat, lon]…])를 브랜드 주황 선으로 그리고 출발·도착 표식을 올린다.
// SDK 를 못 불러오면(키·도메인 미등록) onError 를 부르고 아무것도 그리지 않는다 — 호출 쪽이 지도 칸을 숨긴다
const useStyles = makeStyles(() => ({
  root: { position: 'relative', width: '100%', borderRadius: 12, overflow: 'hidden', border: `1px solid ${tokens.line}`, backgroundColor: tokens.surfaceSoft },
  canvas: { width: '100%', height: '100%' },
}));

const pin = (label, fill) => `<div style="display:inline-flex;align-items:center;height:24px;padding:0 9px;border-radius:12px;background:${fill};color:#fff;font:700 12px/1 'Noto Sans KR',sans-serif;letter-spacing:-0.3px;box-shadow:0 2px 6px rgba(0,0,0,.18);transform:translateY(-12px);white-space:nowrap">${label}</div>`;

function RouteMap({ path = [], from, to, height = 200, className, onError }) {
  const cs = useStyles();
  const ref = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!ref.current || !path.length) return undefined;
    loadKakaoMaps().then((maps) => {
      if (!alive || !ref.current) return;
      const points = path.map(([lat, lon]) => new maps.LatLng(lat, lon));
      const map = new maps.Map(ref.current, { center: points[Math.floor(points.length / 2)], level: 7 });
      new maps.Polyline({ map, path: points, strokeWeight: 5, strokeColor: tokens.primary, strokeOpacity: 0.95, strokeStyle: 'solid' });
      const start = from ? new maps.LatLng(from.lat, from.lon) : points[0];
      const end = to ? new maps.LatLng(to.lat, to.lon) : points[points.length - 1];
      new maps.CustomOverlay({ map, position: start, content: pin('출발', tokens.ink), yAnchor: 1 });
      new maps.CustomOverlay({ map, position: end, content: pin('도착', tokens.primaryDark), yAnchor: 1 });
      const bounds = new maps.LatLngBounds();
      points.forEach((p) => bounds.extend(p));
      bounds.extend(start); bounds.extend(end);
      map.setBounds(bounds, 36, 36, 36, 36);
    }).catch(() => { if (!alive) return; setFailed(true); if (onError) onError(); });
    return () => { alive = false; };
  }, [path, from, to]); // eslint-disable-line react-hooks/exhaustive-deps

  if (failed || !path.length) return null;
  return (
    <div className={clsx(cs.root, className)} style={{ height }} aria-label="배송 경로 지도">
      <div ref={ref} className={cs.canvas} />
    </div>
  );
}

export default RouteMap;
